import { useField } from 'formik';
import { Stack } from '@koob/margaret';
import { KoobInputSegmented } from '@koob/ui';
import { FormLabel, ErrorMessageWrapper, FormField } from 'ui/forms';

const SegmentedControlField = ({
  label,
  options,
  touchRequired = true,
  required,
  onChange,
  disabled,
  ...props
}) => {
  const [field, meta, { setValue }] = useField(props);

  const hasError =
    (!touchRequired || Boolean(meta.touched)) && Boolean(meta.error);

  return (
    <FormField style={{ flex: 0 }}>
      {label && (
        <FormLabel>
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </FormLabel>
      )}
      <Stack>
        <KoobInputSegmented
          options={options}
          value={field.value}
          disabled={disabled}
          onChange={(value) => {
            setValue(value);
            onChange?.(value);
          }}
        />
      </Stack>
      {hasError && <ErrorMessageWrapper>{meta.error}</ErrorMessageWrapper>}
    </FormField>
  );
};

export default SegmentedControlField;
